import { Alert, Snackbar } from "@mui/material";
import { IconButton, Slider } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useEffect, useRef, useState } from "react";
import { PauseCircle } from "@mui/icons-material";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { CgRemoveR } from "react-icons/cg";

import GiftingModal from "../modal/GiftingModal";
import SharingModal from "../modal/SharingModal";
import ComingSoonModal from "../modal/ComingSoonModal";
import ConfirmModal from "../modal/ConfirmModal";
import MoreOptionsModal from "../modal/MoreOptionsModal";
import WoopsModal from "../modal/WoopsModal";
import UserContractDeployModal from "../modal/UserContractDeployModal";
import { validateUsersContract } from "../../services/stacks";
import { isUserSignedIn } from "../../services/auth";
import { DislikeMessageCall, LikeMessageCall, ReplyMessageMenue } from "../../services/chime";
import './style.scss';
import ReplyChimeModal from "../modal/ReplyChimeModal";
import { BiShareAlt } from "react-icons/bi";
import { TbMarquee } from "react-icons/tb";

const CustomStyle = styled(Slider)({ color: '#F7931A', '& .MuiSlider-thumb': { backgroundColor: '#FF4500', }, '& .MuiSlider-track': { backgroundColor: '#FFA500', }, '& .MuiSlider-rail': { backgroundColor: '#FFD580', }, height: '25%', padding: '0 0', margin: '0' })

const MediaPlayer = (
    {
        openMediaPlayer, setOpenMediaPlayer,
        playList, setPlayList,
        selectedChimeTx, setSelectedChimeTx,
        setMediaCurrentTime,
        setReplyOpen,
        userSettings
    }
) => {
    const [fullScreen, setFullScreen] = useState(false);
    const [position, setPosition] = useState(0);
    const [duration, setDuration] = useState(0);
    const [mute, setMute] = useState(null);
    const [playorPaused, setPlayorPaused] = useState(false);
    const [posterKey, setPosterKey] = useState(0);

    const [txId, setTxId] = useState('');
    const [tx_Id, setTx_Id] = useState('');
    const [selectedTxId, setSelectedTxId] = useState(null);

    // Misc State
    const [sentimentOptions, setSentimentOptions] = useState({});
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [selectedAuthorPrincipal, setSelectedAuthorPrincipal] = useState('');

    // Modal State
    const [showMoreOptionsModal, setShowMoreOptionsModal] = useState(false);
    const [showReplyChimeModal, setShowReplyChimeModal] = useState(false);
    const [showGiftingModal, setShowGiftingModal] = useState(false);
    const [showSharingModal, setShowSharingModal] = useState(false);
    const [showWoopsModal, setShowWoopsModal] = useState(false);
    const [showComingSoonModal, setShowComingSoonModal] = useState(false);
    const [showUserContractDeployModal, setShowUserContractDeployModal] = useState(false);
    const [userContractStatus, setUserContractStatus] = useState('');
    const [openConfirmModal, setOpenConfirmModal] = useState(false);

    const [selectedTrack, setSelectedTrack] = useState(() => {
        const res = playList.findIndex(item => item.index === selectedChimeTx)
        return res === -1 ? 0 : res;
    });
    const [activeIndex, setActiveIndex] = useState(null);

    const vidRef = useRef(null);
    const divRef = useRef(null);

    // Media player States Trackers +============================>>>>>>>>>>>>>>

    // Track Changed Stoper
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        const index = playList.findIndex(item => item.index === selectedChimeTx)
        if (openMediaPlayer && selectedTrack !== index) {
            setOpenMediaPlayer(false);
        }
    }, [selectedChimeTx])

    // SnackBar Loadup
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;


        console.log({ playList, selectedTrack });
        const { playorPaused, currentTime } = playList[selectedTrack];
        vidElement.load();
        vidElement.currentTime = currentTime;
        if (playorPaused) handlePlayOrPause();
    }, [])

    // Handles play pause displays
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function onPlay() {
            setPlayorPaused(true);
        }
        function onPause() {
            setPlayorPaused(false);
        }

        vidElement.addEventListener('play', onPlay);
        vidElement.addEventListener('pause', onPause);
        return () => {
            vidElement.removeEventListener('play', onPlay);
            vidElement.removeEventListener('pause', onPause);
        }
    }, [])

    // Tracking Mute or Ummute
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        const handleVolumeChange = () => { setMute(vidElement.muted) };
        vidElement.addEventListener('volumechange', handleVolumeChange);
        // Cleanup event listener on component unmount
        return () => {
            vidElement.removeEventListener('volumechange', handleVolumeChange);
        };
    }, []);

    // Fullscreen handler =====>>>
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function onFullscreenChange() {
            if (vidElement.fullscreenElement) {
                vidElement.exitFullscreen();
            } else if (vidElement.mozFullScreenElement) { /* Firefox */
                vidElement.mozCancelFullScreen();
            } else if (vidElement.webkitFullscreenElement) { /* Chrome, Safari and Opera */
                vidElement.webkitExitFullscreen();
            } else if (vidElement.msFullscreenElement) { /* IE/Edge */
                vidElement.msExitFullscreen();
            }
            setFullScreen(!fullScreen);
        }

        // Listeners
        vidElement.addEventListener('fullscreenchange', onFullscreenChange);
        vidElement.addEventListener('mozfullscreenchange', onFullscreenChange);
        vidElement.addEventListener('webkitfullscreenchange', onFullscreenChange);
        vidElement.addEventListener('msfullscreenchange', onFullscreenChange);
        // Cleanup
        return () => {
            vidElement.removeEventListener('fullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('mozfullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('webkitfullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('msfullscreenchange', onFullscreenChange);
        };
    }, []);

    // Handles Snackbar Closing
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        const { index } = playList[selectedTrack];
        return () => {
            setMediaCurrentTime({ currentTime: vidElement.currentTime, playorPaused, index });
        }
    }, [playorPaused]);

    // Duration, Playtime and Stall/Correct Handler
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function handleWaiting() {
            console.log('snackbar player stalled');
            const stalledTime = vidElement.currentTime;
            vidElement.load();
            vidElement.currentTime = stalledTime;
            setPlayorPaused(false);
            vidElement.play().catch(error => console.error('Play error after stall:', error));
        }

        function handleTimeUpdate() { setPosition(vidElement.currentTime) };
        function handleLoadedMetadata() { setDuration(vidElement.duration) };

        // Listeners
        vidElement.addEventListener('timeupdate', handleTimeUpdate);
        vidElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        vidElement.addEventListener('stalled', handleWaiting);
        // Cleanup event listener on component unmount
        return () => {
            vidElement.removeEventListener('timeupdate', handleTimeUpdate);
            vidElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            vidElement.removeEventListener('stalled', handleWaiting);
        };
    }, [])

    // ==========================================<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    // Snackbar Media Player Functions ==========>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    // Handles Close Snackbar Player
    function handlesPlayerClose() {
        setPlayList([]);
        setOpenMediaPlayer();
        setSelectedChimeTx('');
    }

    // Handles Open Playlist Items
    function handleAccordionClick(index) {
        setActiveIndex(activeIndex === 0 ? null : index);
    }

    // Handles Play Selected Item in Playlist
    function handlePlaySelected(index) {
        const vidElement = vidRef.current;
        const { currentTime } = playList[index];
        setSelectedTrack(index);
        vidElement.load();
        vidElement.currentTime = currentTime;
        vidElement.play();
    }

    // Handles remove from PlayList
    function handleRemoveFromPlaylist(index) {
        const vidElement = vidRef.current;

        // Determine the next index to play
        let nextIndex = index;
        const filteredPlaylist = playList.filter((_, i) => i !== index);
        if (playList.length === 1) {
            handlesPlayerClose();
            return;
        } else if (playList.length - 1 === index) {
            nextIndex = index - 1;
        }

        console.log({ nextIndex, index, playList });

        if (playorPaused && selectedTrack === index) {
            vidElement.pause();
            handlePlaySelected(nextIndex)
            setSelectedChimeTx(filteredPlaylist[nextIndex].index);
        }
        // Update the playlist by removing the current index
        setPlayList(filteredPlaylist);
    }

    // Handles seeking
    function seek(value) {
        if (!vidRef) return;
        setPosition(value);
        vidRef.current.currentTime = value;
    }

    // Handles Next
    function next() {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        if (!(selectedTrack >= playList.length - 1)) {
            const { currentTime } = playList[selectedTrack + 1];
            setSelectedTrack(prev => prev + 1);
            vidElement.load();
            vidElement.currentTime = currentTime;
            vidElement.play();
        }
    }

    // Handles Preving
    // function prev() {
    //     const vidElement = vidRef.current;
    //     if (!vidElement) return;

    //     if (!(selectedTrack < 0)) {
    //         const { currentTime } = playList[selectedTrack - 1];
    //         setSelectedTrack(prev => prev - 1);
    //         vidElement.load();
    //         vidElement.currentTime = currentTime;
    //         vidElement.play();
    //     }
    // }

    // Handles Play Pause
    function handlePlayOrPause() {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        if (!playorPaused) {
            vidElement.play()?.catch(error => { console.error('Error playing video:', error); });
        } else {
            vidElement.pause()?.catch(error => { console.error('Error paused video:', error); });
        }
    }

    // Handles Video End
    function handlesMediaEnds() {
        if (!(selectedTrack > playList.length - 1)) next();
        if ((selectedTrack > playList.length - 1)) {
            const vidElement = vidRef.current;
            if (!vidElement) return;
            vidElement.currentTime = 0;
            setPosterKey(prevKey => prevKey + 1);
        }
    }

    // Handles mute unmute
    function handleMuteOrUnmuted() {
        vidRef.current.muted = !vidRef.current.muted;
    }

    // Handles fullscreen triger
    function handleFullScreen() {
        if (!vidRef) return;
        if (vidRef.current.requestFullscreen) {
            vidRef.current.requestFullscreen();
        } else if (vidRef.current.mozRequestFullScreen) { /* Firefox */
            vidRef.current.mozRequestFullScreen();
        } else if (vidRef.current.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
            vidRef.current.webkitRequestFullscreen();
        } else if (vidRef.current.msRequestFullscreen) { /* IE/Edge */
            vidRef.current.msRequestFullscreen();
        }
    }

    // ==========================================<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
    // Extended functions

    //Validate that the user contract is deployed so they can actually call their contract when trying to do actions.
    async function validating(open, value) {
        const { state, txId } = await validateUsersContract();
        console.log({ state, txId });
        setTxId(txId);
        setUserContractStatus(state);
        switch (state) {
            case true:
                open(value);
                break;
            case false:
            case 'success':
            case 'mempool':
            case 'abort_by_post_condition':
            case 'abort_by_response':
                setShowUserContractDeployModal(true);
                break;
            default:
                if (isUserSignedIn()) {
                    setShowUserContractDeployModal(true);
                } else {
                    setShowWoopsModal(true);
                }
                break;
        }
    }

    //Gift Click Handler
    // const handleGiftClick = async (authorPrincipal, Tx_ID) => {
    //     const authedUser = getUserData().profile.stxAddress.testnet;
    //     //const authedUser =  getUserData().profile.stxAddress.mainnet;
    //     if (authedUser === authorPrincipal) {
    //         setErrorMsg("Interacting with your own content is not possible");
    //         setOpenSnackBar(true);
    //         return null
    //     }
    //     setSelectedAuthorPrincipal(authorPrincipal);
    //     setTxId(Tx_ID);
    //     validating(setShowGiftingModal, true); /// This is a bit confusing why this validating is here?
    // };

    //Share Click Handler
    const handleShareClick = (txId) => {
        setSelectedTxId(txId);
        setShowSharingModal(true);
    };

    // Media Play Timer Formating
    function formatDuration(value) {
        const minute = Math.floor(value / 60);
        const secondLeft = Math.floor(value - minute * 60);
        return `${minute}:${secondLeft < 10 ? `0${secondLeft}` : secondLeft}`;
    }

    // ==========================================<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<

    return (
        <>
            <Snackbar open={openMediaPlayer} ref={divRef} className="mediaSnackBar">
                <div>
                    <div className="video-container">
                        <video
                            ref={vidRef}
                            poster={`${playList[selectedTrack]?.thumbnail_url}?${posterKey}`}
                            onEnded={handlesMediaEnds}
                            width="100%" height="100%">
                            <source src={playList[selectedTrack]?.attachment_url} type={playList[selectedTrack]?.videoType ? "video/mp4" : "audio/mp3"} />
                            Your browser does not support the video tag.
                        </video>
                        <div className="custom-controls">
                            <div className="closemediaplayer-button">
                                <IconButton aria-label="play/pause" onMouseDown={handlesPlayerClose}>
                                    <CloseIcon sx={{ color: 'white', height: '15px', width: '15px' }} />
                                </IconButton>
                            </div>

                            <div className="bigPlay">
                                <div className="bigplaywrap">
                                </div>
                                <div className="slider-row">
                                    <CustomStyle className="slider" defaultValue={0} aria-label="Small" valueLabelDisplay="auto" valueLabelFormat={formatDuration(position)} onChange={(_, value) => seek(value)} value={position} min={0} step={1} max={duration} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="accordion">
                        <div className="accordion-item">
                            <div className="accordion-title">

                                <div id="media-actions">
                                    <div className="media-controls">

                                        <div className="control">
                                            <IconButton aria-label="play/pause" onMouseDown={handlePlayOrPause}>
                                                {!playorPaused
                                                    ? <PlayArrowIcon sx={{ color: "#fff" }} />
                                                    : <PauseCircle sx={{ color: "#fff" }} />
                                                }
                                            </IconButton>
                                        </div>

                                        <div className="control" >
                                            <IconButton aria-label="mute" onMouseDown={handleMuteOrUnmuted} >
                                                {!mute
                                                    ? <VolumeUpIcon sx={{ color: "#fff" }} />
                                                    : <VolumeOffIcon sx={{ color: "#fff" }} />
                                                }
                                            </IconButton>
                                        </div>

                                        <div className="control" >
                                            <IconButton aria-label="fullscreen" onMouseDown={handleFullScreen}>
                                                <FullscreenIcon sx={{ color: "#fff" }} />
                                            </IconButton>
                                        </div>

                                        <div className="control" >
                                            <IconButton aria-label="expand" onMouseDown={() => handleAccordionClick(0)}>
                                                {activeIndex === 0
                                                    ? <MdExpandLess color="#fff" />
                                                    : <MdExpandMore color="#fff" />
                                                }
                                            </IconButton>
                                        </div>

                                    </div>
                                </div>

                                {activeIndex === 0 &&
                                    <div className="interation-actions">
                                        <div className="interaction-buttons">
                                            {/* Reply Icon Button */}
                                            <ReplyMessageMenue
                                                validating={validating}
                                                ChimeAuthorPrincipal={playList[selectedTrack]?.ChimeAuthorPrincipal}
                                                Tx_ID={playList[selectedTrack]?.txId}
                                                setSelectedAuthorPrincipal={setSelectedAuthorPrincipal}
                                                setTx_Id={setTx_Id}
                                                setSentimentOptions={setSentimentOptions}
                                                setShowReplyChimeModal={setShowReplyChimeModal}
                                                setReplyOpen={setReplyOpen}
                                                setOpenSnackBar={setOpenSnackBar}
                                                setErrorMsg={setErrorMsg}
                                                replyCounts={playList[selectedTrack]?.replyCount}
                                                replied={playList[selectedTrack]?.replied}
                                                userSettings={userSettings}
                                            />
                                        </div>

                                        <div className="interaction-buttons">
                                            {/* Like Icon Button*/}
                                            <LikeMessageCall
                                                validating={validating}
                                                ChimeAuthorPrincipal={playList[selectedTrack]?.ChimeAuthorPrincipal}
                                                Tx_ID={playList[selectedTrack]?.txId}
                                                setOpenSnackBar={setOpenSnackBar}
                                                setErrorMsg={setErrorMsg}
                                                setTx_Id={setTx_Id}
                                                setOpenConfirmModal={setOpenConfirmModal}
                                                likeCounts={playList[selectedTrack]?.likeCount}
                                                liked={playList[selectedTrack]?.liked}
                                                userSettings={userSettings}
                                            />
                                        </div>

                                        <div className="interaction-buttons">
                                            {/* Dislike Icon Button */}
                                            <DislikeMessageCall
                                                validating={validating}
                                                ChimeAuthorPrincipal={playList[selectedTrack]?.ChimeAuthorPrincipal}
                                                Tx_ID={playList[selectedTrack]?.txId}
                                                setOpenSnackBar={setOpenSnackBar}
                                                setErrorMsg={setErrorMsg}
                                                setTx_Id={setTx_Id}
                                                setOpenConfirmModal={setOpenConfirmModal}
                                                disLikeCounts={playList[selectedTrack]?.disLikeCount}
                                                disliked={playList[selectedTrack]?.disliked}
                                                userSettings={userSettings}
                                            />
                                        </div>

                                        {/* <div className="interaction-buttons">
                                            <button className="derupt-button" onMouseDown={() => handleGiftClick(authorPrincipal, contenttxId)}><BiGift size={24} /></button>
                                        </div> */}

                                        <div className="interaction-buttons">
                                            <button className="derupt-button" onMouseDown={() => handleShareClick(playList[selectedTrack]?.txId)}><BiShareAlt size={24} /></button>
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className="accordion-content" style={{ maxHeight: activeIndex === 0 ? '200px' : '0', padding: activeIndex === 0 ? '5px' : '0px' }}>
                                {playList.length > 0 && playList.map((_, index) => (
                                    <div className="accordion-items" key={index}>
                                        <div id="preview-video-element">
                                            <video
                                                poster={playList[index]?.thumbnail_url}
                                                width="100%"
                                                className="prev-video">
                                                <source src={playList[index]?.attachment_url} type={playList[index]?.videoType ? "video/mp4" : "audio/mp3"} />
                                                Your browser does not support the video tag.
                                            </video>
                                            <div id="prev-custom-controls">
                                                <div className="bigPlay">
                                                    {(playorPaused && selectedTrack === index)
                                                        ? <IconButton sx={{ color: '#fff' }} aria-label="play/pause" onMouseDown={handlePlayOrPause}><PauseCircle sx={{ color: "#fff" }} /></IconButton>
                                                        : <IconButton sx={{ color: '#fff' }} aria-label="play/pause" onMouseDown={() => handlePlaySelected(index)}><PlayArrowIcon sx={{ color: "#fff" }} /></IconButton>
                                                    }
                                                </div>
                                            </div>

                                        </div>

                                        <div id="preview-content-element">
                                            <div className="marquee-container">
                                                {/* <div className="marquee-text"> */}
                                                <marquee scrollamount="3" behavior="scroll">
                                                    {playList[index]?.content}
                                                </marquee>
                                                {/* </div> */}
                                            </div>
                                            {/* <div id="marquee-container"></div> */}
                                            <div id="small-text-element">{`${String(playList[index]?.txId).substring(0, 4)}...${String(playList[index]?.txId).substring(String(playList[index]?.txId).length - 4, String(playList[index]?.txId).length)}`}</div>
                                        </div>

                                        <div id="preview-remove-element">
                                            <IconButton sx={{ fontSize: '2rem' }} aria-label="play/pause" onMouseDown={() => handleRemoveFromPlaylist(index)}>
                                                <CgRemoveR color="#fff" />
                                            </IconButton>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </Snackbar >

            {/* Modals */}
            <ReplyChimeModal show={showReplyChimeModal} close={() => setShowReplyChimeModal(false)} setShow={setShowReplyChimeModal}
                selectedChimeAuthorPrincipal={selectedAuthorPrincipal}
                tx_Id={tx_Id} sentimentOptions={sentimentOptions}
                setOpenConfirmModal={setOpenConfirmModal}
                setTx_Id={setTx_Id}
                setReplyOpen={setReplyOpen}
                setErrorMsg={setErrorMsg}
                setOpenSnackBar={setOpenSnackBar}
                userSettings={userSettings}
            />

            <GiftingModal show={showGiftingModal} setShow={setShowGiftingModal} close={() => setShowGiftingModal(false)} authorPrincipal={selectedAuthorPrincipal} giftVia={txId} userSettings={userSettings} />
            <SharingModal show={showSharingModal} close={() => setShowSharingModal(false)} txId={selectedTxId} />
            <ComingSoonModal show={showComingSoonModal} setShow={setShowComingSoonModal} close={() => setShowComingSoonModal(false)} />
            <ConfirmModal show={openConfirmModal} setShow={setOpenConfirmModal} txId={tx_Id} close={() => setOpenConfirmModal(false)} userSettings={userSettings} />
            <MoreOptionsModal show={showMoreOptionsModal} setShow={setShowMoreOptionsModal} close={() => setShowMoreOptionsModal(false)} txId={selectedTxId} authorPrincipal={selectedAuthorPrincipal} userSettings={userSettings} />
            <WoopsModal show={showWoopsModal} setShow={setShowWoopsModal} close={() => setShowWoopsModal(false)} />
            <UserContractDeployModal show={showUserContractDeployModal} setShow={setShowUserContractDeployModal} txId={txId} setTxId={setTxId} openConfirmModal={setOpenConfirmModal} setTx_Id={setTx_Id} userContractStatus={userContractStatus} setUserContractStatus={setUserContractStatus} userSettings={userSettings} />

            {/* Snack bar alert */}
            <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={() => setOpenSnackBar(false)}>
                <Alert onClose={() => setOpenSnackBar(false)} severity="error" sx={{ width: '100%' }}> {errorMsg} </Alert>
            </Snackbar>
        </>

    )
}

export default MediaPlayer;